import React from "react";

export function BottomBar({
  currentPage = 1,
  totalPages = 1,
  onPageChange = () => {},
  onZoomIn = () => {},
  onZoomOut = () => {},
  onFullscreen = () => {},
  isFullscreen = false,
}) {
  return (
    <div className="bottom-bar" role="toolbar" aria-label="Viewer controls">
      <div className="bottom-page">
        {currentPage} / {totalPages}
      </div>

      <input
        className="bottom-slider"
        type="range"
        min="1"
        max={totalPages}
        value={currentPage}
        onChange={(e) => onPageChange(Number(e.target.value))}
        aria-label="Go to page"
      />

      <div className="bottom-actions">
        {/* Zoom Out */}
        <button
          className="bottom-icon"
          title="Zoom Out"
          onClick={(e) => {
            e.preventDefault();
            onZoomOut();
          }}
          aria-label="Zoom out"
        >
          <svg
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeWidth="2.2"
              d="m21 21-3.5-3.5M7 10h6m4 0a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
            />
          </svg>
        </button>

        {/* Zoom In */}
        <button
          className="bottom-icon"
          title="Zoom In"
          onClick={(e) => {
            e.preventDefault();
            onZoomIn();
          }}
          aria-label="Zoom in"
        >
          <svg
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeWidth="2.2"
              d="m21 21-3.5-3.5M10 7v6m-3-3h6m4 0a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
            />
          </svg>
        </button>

        {/* Fullscreen */}
        <button
          className="bottom-icon"
          title={isFullscreen ? "Exit fullscreen" : "Fullscreen"}
          onClick={(e) => {
            e.preventDefault();
            onFullscreen();
          }}
          aria-label={isFullscreen ? "Exit fullscreen" : "Enter fullscreen"}
        >
          <svg
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2.2"
              d="M8 4H4m0 0v4m0-4 5 5m7-5h4m0 0v4m0-4-5 5M8 20H4m0 0v-4m0 4 5-5m7 5h4m0 0v-4m0 4-5-5"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}

export default BottomBar;
